import React, { useState, useEffect } from "react";
import axios from "axios";

const HeroSection = () => {
  const [heroSectionData, setHeroSectionData] = useState();
  const [loading, setLoading] = useState(true); // Track loading state

  const showHeroSection = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_KEY}/heroSection/getHeroSection/674586f39aa6780fb2688685`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        setHeroSectionData(response.data.data);
        setLoading(false); // Data fetched, set loading to false
      })
      .catch((error) => {
        console.log(error);
        setLoading(false); // In case of error, set loading to false
      });
  };

  useEffect(() => {
    showHeroSection();
  }, []);

  const handleBookNow = () => {
    const phoneNumber = '917327986868'; // Replace with your phone number including country code
    const message = `Hello, I would like to book an appointment with you.`;

    // URL encode the message to make sure it's formatted correctly
    const encodedMessage = encodeURIComponent(message);

    // Open WhatsApp with pre-filled message
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

    // Open the WhatsApp chat
    window.open(whatsappUrl, '_blank');
  };

  return (
    <React.Fragment>
      {/* Large screen Hero Section */}
      <div
        className={`hidden md:block md:py-10 text-center ${loading ? "bg-orange-200" : ""
          }`}
        style={{
          backgroundImage: loading
            ? "none"
            : `url(${heroSectionData?.[0]?.bgImg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right",
        }}
      >
        <div className="text-start text-black p-16 z-10 md:space-y-8">
          {loading ? (
            <>
              {/* Skeleton Loader for heading */}
              <div className="w-3/4 h-10 bg-orange-300 animate-pulse mb-4"></div>
              {/* Skeleton Loader for subheading */}
              <div className="w-2/4 h-6 bg-orange-300 animate-pulse mb-6"></div>
              {/* Skeleton Loader for button */}
              <div className="w-32 h-12 bg-orange-300 animate-pulse"></div>
            </>
          ) : (
            <>
              <h1
                style={{ fontFamily: "Noto Serif Georgian, serif" }}
                className="text-with-stroke text-3xl md:text-7xl font-serif mb-4 tracking-wider  md:text-start md:mt-0 mt-10 font-bold md:font-medium text-[#202020]"
              >
                <p>{heroSectionData?.[0]?.heading}</p>
              </h1>
              <p className="text-base text-[#313030] md:text-lg mb-2 tracking-wide lg:text-start font-bold md:w-[70%] lg:w-[40%] md:font-bold ">
                {heroSectionData?.[0]?.subheading}
              </p>
              <button
                onClick={handleBookNow}
                className="py-3 px-12 text-white font-semibold bg-[#ff6a00] rounded">
                Book Now
              </button>
            </>
          )}
        </div>
      </div>

      {/* Mobile screen Hero Section */}
      <div
        className={`block md:hidden md:py-10 text-center ${loading ? "bg-orange-200" : ""
          }`}
        style={{
          backgroundImage: loading
            ? "none"
            : `url(${heroSectionData?.[0]?.bgImg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <div className="text-start text-black p-8 max-w-7xl z-10 md:w-1/2 md:space-y-12">
          {loading ? (
            <>
              {/* Skeleton Loader for heading */}
              <div className="w-3/4 h-10 bg-orange-300 animate-pulse mb-4"></div>
              {/* Skeleton Loader for subheading */}
              <div className="w-2/4 h-6 bg-orange-300 animate-pulse mb-6"></div>
              {/* Skeleton Loader for button */}
              <div className="w-32 h-12 bg-orange-300 animate-pulse"></div>
            </>
          ) : (
            <>
              <h1
                style={{ fontFamily: "Noto Serif Georgian, serif" }}
                className="text-with-stroke-small text-3xl md:text-7xl font-serif mb-4 tracking-widest text-center lg:text-start md:mt-0 mt-10 font-bold md:font-medium text-[#202020]"
              >
                <p>{heroSectionData?.[0]?.heading}</p>
              </h1>
              <p className="text-base text-[#313030] md:text-lg mb-6 tracking-wide text-center lg:text-start font-bold md:font-normal ">
                <p>{heroSectionData?.[0]?.subheading}</p>
              </p>
              <div className="flex justify-center">
                <button
                  onClick={handleBookNow}
                  className="py-3 px-12 text-white font-semibold bg-[#ff6a00] rounded">
                  Book Now
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default HeroSection;
